import { apiFetch } from "./client";

export interface NotificationConfig {
  id: string;
  companyId: string;
  channel: "teams_webhook" | "teams_graph" | "outlook";
  webhookUrl: string | null;
  recipientEmail: string | null;
  chatId: string | null;
  events: string[];
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateNotificationConfigInput {
  companyId: string;
  channel: "teams_webhook" | "teams_graph" | "outlook";
  webhookUrl?: string;
  recipientEmail?: string;
  chatId?: string;
  events: string[];
  enabled?: boolean;
}

export interface UpdateNotificationConfigInput {
  webhookUrl?: string | null;
  recipientEmail?: string | null;
  chatId?: string | null;
  events?: string[];
  enabled?: boolean;
}

export const notificationsApi = {
  list: (companyId: string) =>
    apiFetch<NotificationConfig[]>(`/notifications?companyId=${companyId}`),
  get: (id: string) =>
    apiFetch<NotificationConfig>(`/notifications/${id}`),
  create: (data: CreateNotificationConfigInput) =>
    apiFetch<NotificationConfig>("/notifications", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  update: (id: string, data: UpdateNotificationConfigInput) =>
    apiFetch<NotificationConfig>(`/notifications/${id}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),
  delete: (id: string) =>
    apiFetch<{ success: boolean }>(`/notifications/${id}`, {
      method: "DELETE",
    }),
};
